import { Datagrid, List, TextField } from "react-admin";

function ComponentList(props) {
  return (
    <List {...props}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="name" />
      </Datagrid>
    </List>
  );
}

export default ComponentList;
